export const filterObject = (obj, keys, mode = "omit") => {
  if (!obj || typeof obj !== "object") return {};
  if (!Array.isArray(keys)) return { ...obj };

  return Object.fromEntries(
    Object.entries(obj).filter(([key]) =>
      mode === "pick" ? keys.includes(key) : !keys.includes(key)
    )
  );
};
